import React from 'react';

import Icon from '../Icon/Icon';

const InfoIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' className='text-primary' {...props}>
            <circle cx='12' cy='12' r='8.25' stroke='currentColor' strokeWidth='1.5' />
            <circle cx='12' cy='7.875' r='.75' fill='currentColor' />
            <rect x='11.25' y='9.528' width='1.5' height='7.425' rx='.75' fill='currentColor' />
        </Icon>
    );
};

export default InfoIcon;
